'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ = require('../');

var _materialUi = require('material-ui');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var TaskStatusSelect = (_temp = _class = function (_TaskStatus) {
  _inherits(TaskStatusSelect, _TaskStatus);

  function TaskStatusSelect() {
    _classCallCheck(this, TaskStatusSelect);

    return _possibleConstructorReturn(this, _TaskStatus.apply(this, arguments));
  }

  TaskStatusSelect.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        value = _props.value,
        data = _props.data,
        classes = _props.classes,
        defaultValue = _props.defaultValue,
        name = _props.name,
        inEditMode = _props.inEditMode,
        inputProps = _props.inputProps,
        other = _objectWithoutProperties(_props, ['value', 'data', 'classes', 'defaultValue', 'name', 'inEditMode', 'inputProps']);

    var objects = data.objects,
        loading = data.loading;

    if (!objects) {
      return null;
    }

    var values = objects.values;
    var output = null;

    if (inEditMode) {
      output = _react2.default.createElement(_materialUi.Select, _extends({
        value: value || "" // defaultValue={defaultValue}
        ,
        inputProps: _extends({
          name: name,
          label: "Статус"
        }, inputProps)
      }, other), values.map(function (n) {
        var value = n.name;

        var name = _this2.lexicon(value);

        return _react2.default.createElement('option', {
          key: name,
          value: value,
          className: [classes.status, classes.item, classes['status' + value]].join(" ")
        }, name);
      }));
    } else {
      output = _react2.default.createElement('div', null, _react2.default.createElement(_materialUi.Typography, {
        variant: 'caption'
      }, this.lexicon("Status")), _react2.default.createElement(_materialUi.Typography, null, this.lexicon(value)));
    }

    return output;
  };

  return TaskStatusSelect;
}(_.TaskStatusItem), _class.propTypes = _extends({}, _.TaskStatusItem.propTypes, {
  value: _propTypes2.default.string.isRequired,
  defaultValue: _propTypes2.default.string.isRequired,
  name: _propTypes2.default.string.isRequired,
  onChange: _propTypes2.default.func.isRequired
}), _class.defaultProps = _extends({}, _.TaskStatusItem.defaultProps, {
  defaultValue: "New",
  name: "status"
}), _temp); // export default processors(withStyles(styles)(props => <TaskStatusSelect
//   {...props}
// />));

exports.default = (0, _materialUi.withStyles)(_.styles)(function (props) {
  return _react2.default.createElement(_.TaskStatusConnector, _extends({}, props, {
    View: TaskStatusSelect
  }));
});
module.exports = exports['default'];